// about vue-i18n
// The MIT License (MIT)
// 
// Copyright (c) 2020 kazuya kawaguchi
// 
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
// 
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

import { createI18n } from 'vue-i18n';

import message_de from './de.json';
import message_en from './en.json';
import message_es from './es.json';
import message_fr from './fr.json';
import message_it from './it.json';
import message_ja from './ja.json';
import message_ru from './ru.json';
import message_zh from './zh.json';
import error_en from '@/common/i18n/en.json';
import error_ja from '@/common/i18n/ja.json';
import error_zh from '@/common/i18n/zh.json';
import error_it from '@/common/i18n/it.json';
import error_es from '@/common/i18n/es.json';
import error_fr from '@/common/i18n/fr.json';
import error_de from '@/common/i18n/de.json';
import error_ru from '@/common/i18n/ru.json';

const LANGUAGES = {
    'de': { message: message_de, error: error_de },
    'en': { message: message_en, error: error_en },
    'es': { message: message_es, error: error_es },
    'fr': { message: message_fr, error: error_fr },
    'it': { message: message_it, error: error_it },
    'ja': { message: message_ja, error: error_ja },
    'ru': { message: message_ru, error: error_ru },
    'zh': { message: message_zh, error: error_zh },
};

export default createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: LANGUAGES,
    legacy: false,
    globalInjection: true,
    warnHtmlMessage: false
});